<template>
  <div class="v2-reviews">
    <div class="section-header mb-3 mb-md-4">
      <h2 id="reviews" class="mb-0">
        {{ t("Oooh! Porn Reviews") }}
      </h2>
    </div>

    <app-carousel
      :breakpoints="{
        576: {
          itemsToShow: 2,
        },
        992: {
          itemsToShow: 3,
        },
        1281: {
          itemsToShow: 4,
        },
      }"
      theme="dark"
      @page-change="pageChange"
    >
      <slide v-for="(item, i) in reviews" :key="i">
        <div class="review-item" :class="getClass(i)">
          <div class="review">
            <div class="quotes mb-2">
              <i class="icon icon-quote" />
              <i class="icon icon-quote" />
            </div>
            <div>{{ item.review }}</div>
          </div>
          <div class="customer">
            <div class="avatar">
              <img v-lazy="item.avatar" :alt="`review avatar ${i}`" width="56" height="56" />
            </div>
            <div class="personal-info">
              <div class="name">
                {{ item.name }}
              </div>
              <div class="country">
                {{ item.country }}
              </div>
            </div>
          </div>
        </div>
      </slide>
    </app-carousel>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { Slide } from "vue3-carousel";
import AppCarousel from "@/components/v2/app-carousel/index.vue";
import { amplitudeCarouselTrack } from "@/utils/amplitude";
import woman1Avatar from "@/assets/v2/images/feedback-avatars/woman1.png";
import woman2Avatar from "@/assets/v2/images/feedback-avatars/woman2.png";
import woman3Avatar from "@/assets/v2/images/feedback-avatars/woman3.png";
import man1Avatar from "@/assets/v2/images/feedback-avatars/man1.png";
import man2Avatar from "@/assets/v2/images/feedback-avatars/man2.png";
import man3Avatar from "@/assets/v2/images/feedback-avatars/man3.png";
import man4Avatar from "@/assets/v2/images/feedback-avatars/man4.png";
import man5Avatar from "@/assets/v2/images/feedback-avatars/man5.png";
import man6Avatar from "@/assets/v2/images/feedback-avatars/man6.png";

defineOptions({
  name: "reviews",
});

const { locale, t } = useI18n();

interface Review {
  review: string;
  name: string;
  avatar: any;
  country: string;
}

interface ReviewsData {
  en: Review[];
  de: Review[];
  [key: string]: Review[];
}

const allReviews = ref<ReviewsData>({
  en: [
    {
      review:
        "The lightness, the natural bodies, the close intimacy - I find all that really hot. The gentlemen's visits and the orgies are also unique. And especially important is the humour with which Ersties present themselves",
      name: "Katharina",
      avatar: woman1Avatar,
      country: "Germany",
    },
    {
      review:
        "Who said you can’t teach an old dog new tricks.\n" +
        "I have never learned so much about the female anatomy as from watching your recent video featuring Sophie K.\n" +
        "The videos were absolutely Breathtaking.",
      name: "Photoshopboy",
      avatar: man3Avatar,
      country: "United States",
    },
    {
      review:
        'First off I\'m SO HAPPY! I have found your website! I can Really see a big difference with what you produce compared to the "box store" porn sites! I agree with your assessment of making movies, shot by Women and produced by Women!',
      name: "Kendall",
      avatar: woman2Avatar,
      country: "United States",
    },
    {
      review:
        "Hello dear ersties team, I am totally excited about your platform and find you and the girls absolutely great! You can tell that you work with a lot of love and attentiveness and your girls are very relaxed.",
      name: "Frank W",
      avatar: man5Avatar,
      country: "Germany",
    },
    {
      review:
        "I like to say thanks for all the awesome content you're making. I get the feeling you truly respect the girls and the content that you produce. Everything feels nice and comfy when I watch your content.",
      name: "wiavmroh",
      avatar: woman3Avatar,
      country: "Netherlands",
    },
    {
      review: "I am happy to discover all the variety of your sexual playground. Authenticity makes it very enjoyable for me.",
      name: "Happychou",
      avatar: man1Avatar,
      country: "France",
    },
    {
      review: "Hi Ersties, My wife and I really enjoy watching the videos on your site and since signing up we don't use any other websites.",
      name: "WouldyaCouldya",
      avatar: man6Avatar,
      country: "United Kingdom",
    },
  ],
  de: [
    {
      review:
        "Ich komme aus Berlin, und hier sind die Ersties-Videos legendär. Nachdem zwei Frauen in meiner Uni-Bibliothek gedreht haben, wurde mein Interesse geweckt. Seitdem bin ich ein Fan.",
      name: "Katharina",
      avatar: woman1Avatar,
      country: "Deutschland",
    },
    {
      review:
        "Muss mal wieder was loswerden: ... was loswerden: Ihr seid und bleibt einfach die Besten!!! Ob Krieg, Strompreiskrise, Klimawandel, Inflation ... ihr bleibt wenigstens stabil!\n Danke dafür.",
      name: "Euer Elmar",
      avatar: man6Avatar,
      country: "Deutschland",
    },
    {
      review:
        "Fazit: Eine wirklich wundervolle Seite, auf der sich insbesondere junge Mädchen ermutigt fühlen, sich zu trauen, Liebe zu leben - egal mit wem, solange Würde und Anstand im Umgang miteinander vorhanden sind.",
      name: "Casiannet",
      country: "Deutschland",
      avatar: woman2Avatar,
    },
    {
      review:
        "Ihr macht tolle Videos, immer wieder. Schaue ich sogar mit meiner Freundin gerne zusammen! Meine Idee bzw ein kleiner Wunsch, ein Video mit Birkenstocks.",
      name: "Philipp",
      country: "Deutschland",
      avatar: man4Avatar,
    },
    {
      review: "Ich bin begeistert von eurer Seite und den Inhalten. Wirklich happy eine Membership bei euch zu haben.\n" + "Danke:-D",
      name: "Sensuality",
      country: "Schweiz",
      avatar: woman3Avatar,
    },
    {
      review: "Ich wollte einfach nochmals eure super geilen und tollen Videos loben! Echt der Hammer! Auch die Rubrik über 30 ist mega!",
      name: "Manu",
      country: "Deutschland",
      avatar: man3Avatar,
    },
    {
      review:
        "Euer Ersties-Stripclub macht eine meiner ältesten erotischen Fantasien wahr: eine Frauen-Welt voller Erotik.\n Danke dafür! :-)\n Viele Grüße",
      name: "Tom",
      avatar: man2Avatar,
      country: "Deutschland",
    },
  ],
});

const reviews = computed<Review[]>(() => {
  const localeKey = locale.value as keyof ReviewsData;
  return allReviews.value[localeKey] || allReviews.value.en;
});

const getClass = (index: number) => {
  switch ((index + 1) % 3) {
    case 0:
      return "shadow-mint";
    case 1:
      return "shadow-pink";
    default:
      return "shadow-peach";
  }
};

const pageChange = () => {
  amplitudeCarouselTrack("Reviews slider");
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
